import React from "react";
import PropTypes from "prop-types";

import { RemoveButton } from "../../../../components/Buttons/RemoveButton";

const hasOwnId = value => value && typeof value === "object" && value.hasOwnProperty("id");

const stripUiId = item => {
  if (!hasOwnId(item)) {
    return item;
  }
  const { id, ...rest } = item;
  return rest;
};

export const ArrayRemoveButton = ({
  arrayHelpers,
  dataArray,
  itemIndex,
  prospectPath,
  updateProspect,
  ...props
}) => (
  <RemoveButton
    onClick={() => {
      const updatedArray = Array.isArray(dataArray)
        ? dataArray.filter((_, idx) => idx !== itemIndex).map(stripUiId)
        : [];

      arrayHelpers.remove(itemIndex);
      updateProspect({
        [prospectPath]: updatedArray
      });
    }}
    {...props}
  />
);

ArrayRemoveButton.propTypes = {
  arrayHelpers: PropTypes.shape({
    remove: PropTypes.func.isRequired
  }).isRequired,
  dataArray: PropTypes.array.isRequired,
  itemIndex: PropTypes.number.isRequired,
  prospectPath: PropTypes.string.isRequired,
  updateProspect: PropTypes.func.isRequired
};
